import Container from './Container';
import { useUserRole } from '@/hooks/useUserRole';

const OnboardedRoutesOutlet = () => {
  const { Layout } = useUserRole();

  return (
    <Container
      cornerRadius={0}
      flexDisplay
      hFull
      wFull
      indention={0}
      className=""
    >
      <Layout />
    </Container>
  );
};

export default OnboardedRoutesOutlet;
